import apiClient from '@services/apiClient';
import { useQuery } from '@tanstack/react-query';

import { useBankProfile } from '../contexts/BankProfileContext';
import { useAuth } from './useAuth';

export interface FxQuotePayload {
	amount: number;
	currency: string;
	account_uuid: string;
	is_reverse: boolean;
}

export interface FxQuoteResponse {
	amount_from: number;
	amount_from_formatted: string;
	amount_to: number;
	amount_to_formatted: string;
	currency_from: string;
	currency_to: string;
	customer_rate: string;
	expires_at: string;
	id: string;
}

const fetchFxQuote = async (
	customerId: string,
	payload: FxQuotePayload,
): Promise<FxQuoteResponse> => {
	const response = await apiClient.post<FxQuoteResponse>(
		`/profiles/${customerId}/transactions/fx-quotes`,
		payload,
	);
	return response.data;
};

export const useFxQuote = (payload?: FxQuotePayload) => {
	const { selectedProfile } = useBankProfile();
	const { session } = useAuth();

	const customerId = selectedProfile?.id;

	return useQuery<FxQuoteResponse>({
		queryKey: [
			'fxQuote',
			customerId,
			payload?.currency,
			payload?.amount,
			payload?.is_reverse,
		],
		queryFn: () => fetchFxQuote(customerId!, payload!),
		enabled:
			!!customerId &&
			!!session?.tokenized &&
			!!payload &&
			!!payload?.currency &&
			!!payload?.amount,
	});
};
